__turbopack_context__.v({
  "afb__book-cover": "PageBuilder-module__3FnvLa__afb__book-cover",
  "book-excerpt-icon": "PageBuilder-module__3FnvLa__book-excerpt-icon",
  "book-info": "PageBuilder-module__3FnvLa__book-info",
  "bookInfo": "PageBuilder-module__3FnvLa__bookInfo",
});
